import { ContractStatus } from '@coin/shared/core/util-models';
import { ManagementGroupShort } from '@coin/shared/core/util-enums';
import { ExceptionalRecognitionEmployee } from './exr-employee.mock-model';

export const MOCK_EXR_EMPLOYEES: ExceptionalRecognitionEmployee[] = [
  {
    id: 'emp-1',
    gid: 'Z005AA17',
    firstname: 'Marco',
    lastname: 'Rossi',
    countryCode: 'it',
    paOrgCode: 'IT-MIL-01',
    contractStatus: ContractStatus.Active,
    companyEntryDate: '2019-04-15',
    spsEligibilityEmploymentPercentage: 1,
    managementGroup: ManagementGroupShort.NonSeniorManagement,
    localLevel: 'L7',
    localCurrencyIsoCode: 'EUR',
    totalTargetCash: 85000
  },
  {
    id: 'emp-2',
    gid: 'Z005CC19',
    firstname: 'Mei',
    lastname: 'Chen',
    countryCode: 'cn',
    paOrgCode: 'CN-SHA-01',
    contractStatus: ContractStatus.Active,
    companyEntryDate: '2021-08-01',
    spsEligibilityEmploymentPercentage: 1,
    managementGroup: ManagementGroupShort.NonSeniorManagement,
    localLevel: 'L6',
    localCurrencyIsoCode: 'CNY',
    totalTargetCash: 420000
  },
  {
    id: 'emp-3',
    gid: 'Z005EE21',
    firstname: 'Isabel',
    lastname: 'Santos',
    countryCode: 'br',
    paOrgCode: 'BR-SAO-01',
    contractStatus: ContractStatus.Active,
    companyEntryDate: '2018-01-10',
    spsEligibilityEmploymentPercentage: 0.8,
    managementGroup: ManagementGroupShort.SeniorManagement,
    localLevel: 'L5',
    localCurrencyIsoCode: 'BRL',
    totalTargetCash: 350000
  },
  {
    id: 'emp-4',
    gid: 'Z005GG23',
    firstname: 'David',
    lastname: 'Kim',
    countryCode: 'kr',
    paOrgCode: 'KR-SEO-01',
    contractStatus: ContractStatus.Active,
    companyEntryDate: '2020-06-22',
    spsEligibilityEmploymentPercentage: 1,
    managementGroup: ManagementGroupShort.NonSeniorManagement,
    localLevel: 'L8',
    localCurrencyIsoCode: 'KRW',
    totalTargetCash: 75000000
  },
  {
    id: 'emp-5',
    gid: 'Z005II25',
    firstname: 'Amira',
    lastname: 'Nkosi',
    countryCode: 'za',
    paOrgCode: 'ZA-JNB-01',
    contractStatus: ContractStatus.Active,
    companyEntryDate: '2017-03-05',
    spsEligibilityEmploymentPercentage: 1,
    managementGroup: ManagementGroupShort.SeniorManagement,
    localLevel: 'L4',
    localCurrencyIsoCode: 'ZAR',
    totalTargetCash: 950000
  },
  {
    id: 'emp-6',
    gid: 'Z005KK27',
    firstname: 'Elena',
    lastname: 'Petrova',
    countryCode: 'de',
    paOrgCode: 'DE-MUC-03',
    contractStatus: ContractStatus.Active,
    companyEntryDate: '2022-11-14',
    spsEligibilityEmploymentPercentage: 0.5,
    managementGroup: ManagementGroupShort.NonSeniorManagement,
    localLevel: 'L9',
    localCurrencyIsoCode: 'EUR',
    totalTargetCash: 62000
  },
  {
    id: 'emp-7',
    gid: 'Z005LL28',
    firstname: 'James',
    lastname: "O'Brien",
    countryCode: 'us',
    paOrgCode: 'US-HOU-01',
    contractStatus: ContractStatus.Active,
    companyEntryDate: '2016-09-01',
    spsEligibilityEmploymentPercentage: 1,
    managementGroup: ManagementGroupShort.TopManagement,
    localLevel: 'L3',
    localCurrencyIsoCode: 'USD',
    totalTargetCash: 145000
  }
];
